module.exports = __webpack_public_path__ + "img/virgo.4b5509c9.svg";